/**
 * Google Analytics 4 (GA4) telemetry helper.
 * Tracks custom SPA route transitions and user interactions.
 */

export const GA_MEASUREMENT_ID = 'G-275P6YQ2E4';

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

export function trackEvent(eventName: string, params?: Record<string, unknown>): void {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    try {
      window.gtag('event', eventName, params);
    } catch {
      // Ignore telemetry errors in ad-blocked environments
    }
  }
}

export function trackPageView(pagePath: string, pageTitle?: string): void {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    try {
      window.gtag('event', 'page_view', {
        page_path: pagePath,
        page_title: pageTitle || document.title,
        page_location: window.location.href,
      });
    } catch {
      // Ignore telemetry errors in ad-blocked environments
    }
  }
}

export function trackCompanyView(companyId: string, companyName: string): void {
  trackEvent('view_company', {
    company_id: companyId,
    company_name: companyName,
  });
}

export function trackDiffView(companyId: string, policyType: string, baseRevId?: string, targetRevId?: string): void {
  trackEvent('view_diff', {
    company_id: companyId,
    policy_type: policyType,
    base_rev_id: baseRevId || '',
    target_rev_id: targetRevId || '',
  });
}
